// auth flow
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const REMOVE_CURRENT_USER = 'REMOVE_CURRENT_USER'

export const SET_PROFILE = 'SET_PROFILE'
export const SET_NEW_PASSWORD = 'SET_NEW_PASSWORD'
export const SET_TOKEN_EXPIRED = 'SET_TOKEN_EXPIRED'

export const SET_AREAS = 'SET_AREAS'
export const SET_SEARCH_AREAS = 'SET_SEARCH_AREAS'

export const SET_INSIGHTS = 'SET_INSIGHTS'
export const SET_SEARCH_INSIGHTS = 'SET_SEARCH_INSIGHTS'


export const SET_TESTS = 'SET_TESTS'
export const SET_SEARCH_TESTS = 'SET_SEARCH_TESTS'

export const SET_NEWS = 'SET_NEWS'
export const SET_SEARCH_NEWS = 'SET_SEARCH_NEWS'